import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import NavigationBar from '../../components/NavigationBar';
import {Form} from 'react-bootstrap';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import {formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import {IActivities, IChannel, IIAS, IIOBSP, IProduct} from '../../../../data/api/models';
import {IAuthState} from '../../../../services/auth/models';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import DeclarationQuestions from '../../components/DeclarationQuestions';
import {hasSameValue} from '../../../../util/validators';
import DeclinesAndReferrals from '../../components/DeclinesAndReferrals';
import {getReferralsAndDeclines} from '../../../../util/helpers';
import {Email} from '../../../../components/Email';

interface IDeclarationsFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };

  ias: IIAS;
  iobsp: IIOBSP;
  declaration: any;
  activities: IActivities;
  renewalRcExploitation: boolean;
}

const customYesText = 'Vrai';
const customNoText = 'Faux';

class DeclarationsForm extends React.Component<IDeclarationsFormProps> {
  public state = {
    declines: [],
    referrals: [],
    errors: [],
  };

  public componentWillReceiveProps(nextProps) {
    if (nextProps.hasOwnProperty('declaration')) {
      this.resetAnswers(nextProps);
    }

    const { quote } = this.props;
    const referralsAndDeclines = getReferralsAndDeclines(quote);
    if (this.state.declines !== referralsAndDeclines.declines) {
      this.setState({ declines: referralsAndDeclines.declines });
    }
    if (this.state.errors !== referralsAndDeclines.errors) {
      this.setState({ errors: referralsAndDeclines.errors });
    }
  }

  private resetAnswers(nextProps) {
    const { dispatch, change, declaration } = this.props;

    if (!declaration) {
      return;
    }

    if (! hasSameValue(nextProps.declaration, declaration, '1')) {
      if (nextProps.declaration[1] !== 'true') {
        dispatch(change('declaration[2]', ''));
        dispatch(change('currentInsurer', ''));
      } else {
        dispatch(change('declaration[3]', ''));
      }
    }
  }

  private getQuestions() {
    const { declaration, ias, iobsp, product, activities, renewal, renewalRcExploitation } = this.props;
    const questions = [];

    // const insurers = [];
    // if (product.metadata.hasOwnProperty('insurers') && product.metadata.insurers instanceof Array) {
    //   product.metadata.insurers.map((insurer) => insurers.push({ label: insurer, value: insurer }));
    // }

    const allQuestions = {
      1: {
        field: 'declaration[1]',
        question: 'Etes vous déjà assuré en RC Professionnelle à ce jour ?',
        // className: ['no-bg'],
      },
      2: {
        field: 'declaration[2]',
        question: 'Auprès de quel assureur ?',
        fieldType: 'select',
        options: [
          { label: 'MS Amlin', value: 'MS Amlin' },
          { label: 'CGPA', value: 'CGPA' },
          { label: 'CNA', value: 'CNA' },
          { label: 'QBE', value: 'QBE' },
          { label: 'Beazley', value: 'Beazley' },
          { label: 'Autre', value: 'Autre' },
        ],
        // className: ['no-bg'],
      },
      currentInsurer: {
        field: 'currentInsurer',
        question: 'Merci d’indiquer le nom de votre assureur actuel',
        fieldType: 'text',
        // options: insurers,
      },
      3: {
        field: 'declaration[3]',
        question: 'S\'agit-il d\'une création? (moins de 6 mois)',
        // className: ['no-bg'],
      },
      4: {
        field: 'declaration[4]',
        question: 'Au cours des 5 dernières années avez-vous fait l\'objet d\'une réclamation ' +
          'ayant engagé votre responsabilité en RC Professionnelle et/ou Garantie Financière ?',
      },
      5: {
        field: 'declaration[5]',
        question: 'Avez-vous connaissance de circonstances susceptibles d\'engager votre ' +
          'RC Professionnelle et/ou Garantie Financière ?',
      },
      6: {
        field: 'declaration[6]',
        question: 'Avez-vous fait  l\'objet d’une résiliation de votre contrat RC Professionnelle et/ou Garantie ' +
          'financière dans les 24 derniers mois ?',
      },
      7: {
        field: 'declaration[7]',
        question: 'Avez-vous fait l\'objet d\'un contrôle de l\'ACPR ayant entraîné une ou ' +
          'plusieurs sanctions à votre encontre ?',
      },
      8: {
        field: 'declaration[8]',
        question: 'Souhaitez-vous souscrire une garantie RC exploitation ?',
      },
      9: {
        field: 'declaration[9]',
        question: 'Ne PAS exercer dans les domaines Aviation/aérospatial',
        labelSize: 8,
        yes: customYesText,
        no: customNoText,
      },
      10: {
        field: 'declaration[10]',
        question: 'Ne PAS réaliser d\'intermédiation en réassurance',
        labelSize: 8,
        yes: customYesText,
        no: customNoText,
      },
      11: {
        field: 'declaration[11]',
        question: 'Ne PAS réaliser d\'intermédiation en service de paiement',
        labelSize: 8,
        yes: customYesText,
        no: customNoText,
      },
      12: {
        field: 'declaration[12]',
        question: 'Ne PAS réaliser d\'intermédiation en crédit en devise autre qu\'en euro',
        labelSize: 8,
        yes: customYesText,
        no: customNoText,
      },
      13: {
        field: 'declaration[13]',
        question: 'Ne PAS exercer votre activité hors de France (dans le cadre de la LPS)',
        labelSize: 8,
        yes: customYesText,
        no: customNoText,
      },
      14: {
        field: 'declaration[14]',
        question: 'Etre domicilié en France métropolitaine ou dans un' +
          ' département d\'outre-mer : Guadeloupe, Martinique, Guyane, La Réunion, Mayotte.',
        labelSize: 8,
        yes: customYesText,
        no: customNoText,
      },
    };
    if (!renewal) {
      questions.push(allQuestions[1]);
      if (declaration && declaration[1] === 'true') {
        questions.push(allQuestions[2]);
        if (declaration && declaration[2] === 'Autre') {
          questions.push(allQuestions.currentInsurer);
        }
      }
      if (declaration && declaration[1] === 'false') {
        questions.push(allQuestions[3]);
      }
      questions.push({ type: 'divider'});
      questions.push(allQuestions[4]);
    }

    questions.push(allQuestions[5]);

    if (!renewal) {
      questions.push(allQuestions[6]);
    }
    if (activities && activities.realEstate.percent !== '100') {
      questions.push(allQuestions[7]);
    }

    if (!renewalRcExploitation) {
      questions.push(allQuestions[8]);
    }

    questions.push({ type: 'divider'});
    questions.push({ type: 'content', content: () => (
        <div>
          <h4>Vous déclarez</h4>
        </div>
      ) });

    // showIAS
    if (ias && ias.included) {
      questions.push(allQuestions[9]);
      questions.push(allQuestions[10]);
    }

    // showIOBSP
    if (iobsp && iobsp.included) {
      questions.push(allQuestions[11]);
      questions.push(allQuestions[12]);
    }

    if (activities && activities.realEstate.percent !== '100') {
      questions.push(allQuestions[13]);
    }

    questions.push(allQuestions[14]);

    return questions;
  }

  private declinesOrReferrals() {
    const {declines, referrals, errors} = this.state;

    if (!declines.length && !referrals.length && !errors.length) {
      return null;
    }

    return (
      <div>
        <DeclinesAndReferrals
          declines={declines}
          referrals={referrals}
          errors={errors}
          quoteReference={this.props.quote.application.quoteReference}
          renewal={this.props.renewal}
        />
        {(! declines.length && ! referrals.length && errors.length) && (
          <NavigationBar
            hasBackButton={true}
            backTo={this.backToLink()}
            hasNextButton={false}
          />
        )}
      </div>
    );
  }

  private backToLink() {
    const { ias, iobsp } = this.props;
    if (iobsp && iobsp.included) {
      return '/iobsp';
    }

    if (ias && ias.included) {
      return '/ias';
    }

    return '/';
  }

  public render() {
    const { handleSubmit, renderDefinition } = this.props;
    const questions = this.getQuestions();

    const declinesOrReferrals = this.declinesOrReferrals();
    if (declinesOrReferrals) {
      return declinesOrReferrals;
    }

    return (
      <Form horizontal={true}
            onSubmit={handleSubmit}
            autoComplete="off">
        <div className="steps-container">
          <h3>
            Déclarations
          </h3>

          <DeclarationQuestions renderDefinition={renderDefinition} questions={questions} />

          <NavigationBar
            hasBackButton={true}
            backTo={this.backToLink()}
            {...this.props}
            nextButtonText={'Obtenir un tarif'}
            nextButtonDisabled={false}
          />
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const declaration = selector(state, 'declaration');
      const ias = selector(state, 'ias');
      const iobsp = selector(state, 'iobsp');
      const activities = selector(state, 'activities');
      const renewalRcExploitation = selector(state, 'renewalRcExploitation');

      return {
        startDate,
        quotationTypes,
        auth: state.auth,
        declaration,
        ias,
        iobsp,
        activities,
        renewalRcExploitation,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(DeclarationsForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Declarations/index.tsx